import React from "react";
import {
  Link
} from "react-router-dom";

import config from './../../config.js';
export default class ListData extends React.Component {
  constructor(props) {
    super(props);
    let user = {};
    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
    }

    this.state = {
      page_title: '数据列表',
      user: user,
      users: [],
      user_size: 0,
      projects: [],
      project_size: 0,
      file_size: 0,
      file_num: 0,
      files: [],
      searchtext_user: '',
      searchtext_project: '',
      current_projectid: ''
    };

    document.title = this.state.page_title;
    this.handleSearchText = this.handleSearchText.bind(this);

  }



  componentDidMount() {
    this.getUsers();
    this.searchproject(0);
  }



  getUsers() {
    const me = this;
    const {
      user
    } = me.state;
    const postdata = {
      type: 'getuserlist',
      managerlevel: user.level,
      companyid: user.company_id,
      Authorization: localStorage.token
    };
    fetch(config.host + '/manager/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1 && json.size > 0) {
          me.setState({
            users: json.data,
            user_size: json.size
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  handleSearchText(event) {
    const target = event.target;
    //const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const value = target.value.trim();
    this.setState({
      [name]: value
    });

    if (name === 'searchtext_user' && value !== '') {
      this.searchuser();
      return;
    }

    if (name === 'searchtext_project' && value !== '') {
      this.searchproject('');
    } else {
      this.getUsers();
    }

  }

  searchuser() {
    const me = this;
    let {
      user,
      searchtext_user
    } = me.state;
    const postdata = {
      type: 'user_search',
      managerlevel: user.level,
      companyid: user.company_id,
      search: searchtext_user,
      Authorization: localStorage.token
    };
    fetch(config.host + '/manager/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1 && json.size > 0) {
          me.setState({
            users: json.data,
            user_size: json.size
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });

  }


  searchproject(userid) {
    const me = this;
    let {
      user,
      searchtext_project
    } = me.state;
    const postdata = {
      type: 'project_search',
      managerlevel: user.level,
      companyid: user.company_id,
      userid: userid,
      search: searchtext_project,
      Authorization: localStorage.token
    };
    fetch(config.host + '/manager/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1 && json.size > 0) {
          me.setState({
            projects: json.data,
            project_size: json.size
          });
        } else {
          me.setState({
            projects: [],
            project_size: 0
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });



    me.setState({
      current_projectid: '',
      files: [],
      file_num: 0,
      file_size: 0
    })
  }

  searchfile(projectid) {

    const me = this;
    let {
      user
    } = me.state;
    const postdata = {
      type: 'project_file',
      managerlevel: user.level,
      companyid: user.company_id,
      projectid: projectid,
      Authorization: localStorage.token
    };
    fetch(config.host + '/manager/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1 && json.size > 0) {
          me.setState({
            files: json.data,
            file_size: me.approx(json.file_size),
            file_num: json.size
          });
        } else {
          me.setState({
            files: [],
            file_size: 0,
            file_num: 0
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });

    me.setState({
      current_projectid: projectid
    })
  }

  approx(bytevalue) { //计算文件单位和大小
    let filebtout = this.state.filebtout;
    for (let units = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], n = 0, Approx = bytevalue / 1024; Approx > 1; Approx /= 1024, n++) {
      filebtout = Approx.toFixed(3) + " " + units[n];
    }
    return filebtout;
  }

  render() {
    const {
      users,
      user_size,
      projects,
      project_size,
      files,
      file_size,
      file_num,
      current_projectid
    } = this.state;
    //console.log(users);
    return (
      <div>
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 ">
          <h3>{this.state.page_title}</h3>
        </div>

        <div className="row">

          <div className="shadow-sm animated slideInRight col-4 sidebar-sticky">
              <h5 className="card-title">用户 <small className="float-right"><span className="badge badge-pill badge-success">{user_size}</span> </small></h5>
              <div className="input-group mb-3">
                <input type="text" className="form-control  b-0" placeholder="搜索：邮箱、姓名、所在单位..." name="searchtext_user" onChange={this.handleSearchText}  />
                <div className="input-group-prepend">
                  <span className="input-group-text" onClick={()=>{this.searchuser()}}><i className="fa fa-fw fa-search"></i></span>
                </div>
              </div>
              <ul className="nav overflowscroll">
              {
                  users.map((item,index)=>{
                    return (
                      <li className="list-group-item  list-group-item-action" key={index} onClick={()=>{this.searchproject(item.id)}}>
                      {item.realname} <small className="text-muted">{item.address} {item.email}</small>
                    </li>
                    );
                  })
                }
              </ul>
          </div>

          <div className="shadow-sm mb-3 col-4 animated slideInLeft sidebar-sticky">
              <h5 className="card-title">项目 <small className="float-right"> <a className="badge badge-info  mx-3"  onClick={()=>{this.searchproject(0)}}>显示全部</a> <span className="badge badge-pill badge-success">{project_size}</span></small>  </h5>
              <div className="input-group mb-3">
                <input type="text" className="form-control  b-0" placeholder="搜索：项目名称..." name="searchtext_project" onChange={this.handleSearchText}  />
                <div className="input-group-prepend">
                  <span className="input-group-text cursor" title="查询全部" onClick={()=>{this.searchproject('')}}><i className="fa fa-fw fa-search"></i></span>
                </div>
              </div>
              <ul className="nav overflowscroll">
                {
                  projects.map((item,index)=>{
                    return (
                      <li className="list-group-item  list-group-item-action" key={index} onClick={()=>{this.searchfile(item.id)}}>
                        {item.name} <small className="text-muted">{item.user} </small>  <i className="fa fa-clock-o"></i> <small className="text-muted">{item.update_time} {item.status==0 ? '(已删除)' : ''}</small>
                      </li>
                    );
                  })
                }
              </ul>
          </div>
      
          <div className="shadow-sm animated slideInRight col-4 sidebar-sticky">
              <h5 className="card-title">文件 
              {
      current_projectid && <small className="mx-2"><Link to={`/console/myprojects/project/${current_projectid}/MR`}>进入项目 <i className="fa fa-angle-right"></i> </Link></small>
              }
              <small className="float-right"><span className="badge badge-pill badge-success">{file_num}件</span> <span className="badge badge-pill badge-success">{file_size}</span> </small></h5>
              <ul className="nav overflowscroll">
              {
                files.map((item, index) => {
                    return (
                      <li className="list-group-item  list-group-item-action" key={index}>
                      <span className="d-inline-block ">{item.file_name} </span>
                      <div><i className="fa fa-clock-o"></i> <small className="text-muted text-nowrap">{item.date_created}</small></div>
                    </li>
                    );
                  })
                }
              </ul>
          </div>
        
        </div>
      </div>


    )
  }



}


// WEBPACK FOOTER //
// ./src/apps/console/manager/list_data.js